export default "__VITE_PUBLIC_ASSET__bc20be1f__"